module.exports = __webpack_public_path__ + "static/media/nxLab.3c9e1592.png";